<template>
  <div>
    <div v-show="!ranfs" class="row">
      <div class="col-12">
        <button type="button" id="copyAnterior" title="Copiar dados de nota anterior"
                @click="$emit('open-modal-copiar')"
                class="btn btn-label btn-sm mb-2 btn-outline-primary"><i
            class="bx bx-copy label-icon"></i> Copiar dados de uma nota anterior
        </button>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <b-form>
          <div class="row">
            <h5 class="mb-3">Dados do {{ prestadorORtomador }}</h5>
          </div>
          <div v-show="!ranfs" class="row">
            <div class="col-xl-3 col-sm-4">
              <label class="card-radio-label mb-3">
                <input
                    type="radio"
                    @change="alterPais"
                    v-bind:disabled="substituicao"
                    v-model="paisTomadorLocal"
                    name="pais-tomador-brasil"
                    id="pais-tomadorbrasil"
                    class="card-radio-input"
                    value="BR"
                />
                <div class="card-radio">
                  <img
                      src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAOCAYAAAAvxDzwAAAA2ElEQVQ4jaWUPQ6CQBCF34JoQWLBAbj/pawsLEhICMt6Bq5gb+MBqIWNpYkR/BsrgcTPajd5s9/OzJudVYQQBn/U6p+pXpfLMhXR+TJhKAAIAJIkvCXJPuBsNE7xQJCQME5wP7sCuAGw+TE7z+bB3A0gF1kFcAhg5Yv7qAAwAuD6S1oALCXBzcegA5qPkA14qATn3BEJdGbBPqA6dBIC0j8ogObJBcUGo2nG4AOAAhjZ2cAwDYAm3cq2wKk+FXtPKv7rAO6TKmcFaAJwORXdQYQ82NWfaZfoC6sdBVDaY8tAAAAAElFTkSuQmCC"
                      alt="Brasil" height="12" class="mr-1">
                  <span>{{ prestadorORtomador }} Brasileiro</span>
                </div>
              </label>
            </div>
            <div class="col-xl-3 col-sm-4">
              <label class="card-radio-label mb-3">
                <input
                    type="radio"
                    @change="alterPais"
                    v-bind:disabled="substituicao"
                    v-model="paisTomadorLocal"
                    name="pais-tomador-fora"
                    id="pais-tomadorfora"
                    class="card-radio-input"
                    value="FORA"
                />
                <div class="card-radio">
                  <span>{{ prestadorORtomador }} Estrangeiro</span>
                </div>
              </label>
            </div>
          </div>
          <div v-if="paisTomadorLocal !== 'BR'" class="row">
            <div class="col-12 mt-1 mb-2">
              <multiselect
                  id="pas_codigo"
                  v-model="localTomador.pas_codigo"
                  placeholder="Selecione o país"
                  track-by="pas_codigo"
                  :custom-label="labelPais"
                  :options="paises"
                  :close-on-select="true"
                  :allowEmpty="false"
                  :option-height="104"
                  :loading="isLoading"
                  :searchable="true"
                  :internal-search="false"
                  :max-height="600"
                  :show-no-results="false"
                  @search-change="pesquisarPais"
                  :show-labels="false">
                <template #option="props">
                  <div class="option__desc">
                    <span class="option__title">{{ props.option.pas_codigo }} - {{ props.option.pas_nome }}</span>
                  </div>
                </template>
                <span slot="noOptions">Digite para pesquisar</span>
              </multiselect>
            </div>
          </div>

          <!-- Tomador Estrangeiro -->
          <div v-if="isEstrangeiro">
            <div class="row">
              <div class="col-md-4">
                <b-form-group label="NIF" label-for="sep_nif_tomador">
                  <input class="form-control" v-model="localTomador.sep_nif_tomador"
                         maxlength="40" id="sep_nif_tomador" type="text">
                </b-form-group>
              </div>
              <div class="col-md-4">
                <b-form-group label="Nome Completo ou Razão social" label-for="sep_razao_social_tomador">
                  <input class="form-control" v-model="localTomador.sep_razao_social_tomador"
                         maxlength="150"
                         :class="{ 'is-invalid': erroRazaoSocial }"
                         id="tps_razao_social_nome" type="text">
                  <div v-if="erroRazaoSocial" class="invalid-feedback">
                    Informe o Nome/Razão social
                  </div>
                </b-form-group>
              </div>
              <div class="col-md-4">
                <b-form-group label="E-mail" label-for="sep_email_tomador">
                  <input v-model="localTomador.sep_email_tomador"
                         class="form-control" maxlength="80"
                         id="sep_email_tomador" type="email">
                </b-form-group>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <div class="row">
                  <h5 class="mb-3">Endereço do {{ prestadorORtomador }}</h5>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-12">
                <b-form-group id="endexterior-group"
                              label="Endereço completo do Tomador no exterior"
                              label-for="sep_endereco_tomador">
                  <input id="endexterior" ref="sep_endereco_tomador"
                         v-model="localTomador.sep_endereco_tomador"
                         type="text" maxlength="255" class="form-control" placeholder=" "
                         :class="{'is-invalid': erroEndereco}">
                  <div v-show="erroEndereco" class="invalid-feedback">
                    Informe o endereço. Máximo de 255 caracteres
                  </div>
                </b-form-group>
              </div>
            </div>
          </div>

          <!-- Tomador Brasileiro -->
          <div v-else>
            <div class="row">
              <div class="col-md-4">
                <b-form-group label="CPF ou CNPJ *" label-for="sep_cpf_cnpj_tomador">
                  <the-mask class="form-control"
                            :class="{ 'is-invalid': validation.cpfCnpj || cpfCnpjInvalid || tomadorIsPrestador}"
                            v-model="localTomador.sep_cpf_cnpj_tomador"
                            :disabled="substituicao"
                            v-on:focusout.native="$emit('loc-tomador', localTomador.sep_cpf_cnpj_tomador)"
                            :mask="['###.###.###-##', '##.###.###/####-##']"/>
                  <div v-if="validation.cpfCnpj" class="invalid-feedback">
                    Informe o CPF ou CNPJ
                  </div>
                  <div v-show="cpfCnpjInvalid" class="invalid-feedback">
                    CPF ou CNPJ Inválido
                  </div>
                  <div v-show="tomadorIsPrestador" class="invalid-feedback">
                    CPF ou CNPJ do tomador não pode ser idêntico ao do Prestador
                  </div>
                </b-form-group>
              </div>
              <div class="col-md-5">
                <b-form-group label="Nome Completo ou Razão Social *" label-for="sep_razao_social_tomador">
                  <input class="form-control" v-model="localTomador.sep_razao_social_tomador"
                         maxlength="150"
                         :class="{ 'is-invalid': validation.razaoSocial }"
                         id="tps_razao_social_nome" type="text">
                  <div v-if="validation.razaoSocial" class="invalid-feedback">
                    Informe o Nome/Razão social
                  </div>
                </b-form-group>
              </div>
              <div class="col-md-3">
                <b-form-group label="Telefone" :state="telefoneValido"
                              invalid-feedback="Informe um telefone válido com DDD"
                              label-for="sep_telefone_tomador">
                  <the-mask class="form-control"
                            v-model="localTomador.sep_telefone_tomador"
                            :mask="['(##) ##### ####', '(##) #### ####']"/>
                </b-form-group>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <b-form-group label="E-mail" :state="emailValido" invalid-feedback="Informe um e-mail válido"
                              label-for="sep_email_tomador">
                  <input v-model="localTomador.sep_email_tomador"
                         class="form-control" maxlength="80"
                         id="sep_email_tomador" type="email">
                </b-form-group>
              </div>
              <div class="col-md-3">
                <b-form-group label="Inscrição municipal" label-for="sep_inscricao_municipal_tomador">
                  <input class="form-control" maxlength="15"
                         v-bind:disabled="localTomador.eco_inscricaomunicipal"
                         v-model="localTomador.sep_inscricao_municipal_tomador"
                         id="sep_inscricao_municipal_tomador" type="text">
                </b-form-group>
              </div>
              <div class="col-md-3">
                <b-form-group label="Inscrição estadual" label-for="sep_inscricao_estadual_tomador">
                  <input class="form-control" maxlength="15"
                         v-model="localTomador.sep_inscricao_estadual_tomador"
                         id="sep_inscricao_estadual_tomador" type="text">
                </b-form-group>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <div class="row">
                  <h5 class="mb-3">Endereço do {{ prestadorORtomador }}</h5>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-3">
                <b-form-group id="cep-group" :state="cepValido" label="CEP *" label-for="cep-reply"
                              invalid-feedback="Informe um CEP válido">
                  <input id="cep-reply" ref="sep_cep_tomador"
                         v-model="localTomador.sep_cep_tomador"
                         v-on:focusout="$emit('loc-cep', localTomador.sep_cep_tomador)"
                         autocomplete="no" v-mask="'#####-###'"
                         type="text" maxlength="20" class="form-control" placeholder=" "
                         :class="{'is-invalid': errorCep || (submitted && validation.cep)}">
                  <div v-show="validation.cep" class="invalid-feedback">
                    Informe o CEP do {{ prestadorORtomador }}
                  </div>
                  <div v-show="errorCep" class="invalid-feedback">
                    CEP não encontrado
                  </div>
                </b-form-group>
              </div>
              <div class="col-md-6">
                <b-form-group id="cidade-group" label="Cidade - UF" label-for="cidade">
                  <h5 v-if="localTomador.sep_municipio_tomador" class="mb-3 mt-3">
                    {{ localTomador.mun_nome }} - {{ localTomador.mun_uf }}
                  </h5>
                </b-form-group>
              </div>
            </div>
            <div class="row">
              <div class="col-md-5">
                <b-form-group id="quadra-group" label="Endereço/Quadra *" label-for="sep_endereco_tomador">
                  <input id="quadra" ref="sep_endereco_tomador"
                         v-model="localTomador.sep_endereco_tomador"
                         type="text" maxlength="255" class="form-control" placeholder=" "
                         :class="{'is-invalid': submitted && validation.endereco}">
                  <div v-show="validation.endereco" class="invalid-feedback">
                    Informe o endereço. Máximo de 255 caracteres
                  </div>
                </b-form-group>
              </div>
              <div class="col-md-3">
                <b-form-group id="lote-group" label="Número/Lote *" label-for="sep_numero_endereco_tomador">
                  <input id="sep_numero_endereco_tomador" ref="sep_numero_endereco_tomador"
                         v-model="localTomador.sep_numero_endereco_tomador"
                         type="text" maxlength="10" class="form-control" placeholder=" "
                         :class="{'is-invalid': submitted && validation.numero}">
                  <div v-show="validation.numero" class="invalid-feedback">
                    Informe o número. Máximo de 10 caracteres
                  </div>
                </b-form-group>
              </div>
              <div class="col-md-4">
                <b-form-group id="bairro-group" label="Bairro *" label-for="sep_bairro_tomador">
                  <input id="sep_bairro_tomador"
                         v-model="localTomador.sep_bairro_tomador"
                         type="text" maxlength="60" class="form-control" placeholder=" "
                         :class="{'is-invalid': submitted && validation.bairro}">
                  <div v-show="validation.bairro" class="invalid-feedback">
                    Informe o bairro. Máximo de 60 caracteres
                  </div>
                </b-form-group>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <b-form-group id="complemento-group" label="Complemento" label-for="complemento">
                  <input id="complemento" v-model="localTomador.sep_complemento_endereco_tomador"
                         type="text" maxlength="60" class="form-control"
                         :class="{'is-invalid': submitted && validation.complemento}"
                         placeholder=" ">
                  <div v-show="validation.complemento" class="invalid-feedback">
                    Complemento deve ter no máximo 60 caracteres
                  </div>
                </b-form-group>
              </div>
            </div>
          </div>
        </b-form>
      </div>
    </div>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
import {TheMask} from 'vue-the-mask'
import {autocompletePaises} from "@/api/geral/autocomplete";
import {validarEmail, validarTelefoneBR} from "@/helps/util";

export default {
  name: "TabTomador",
  components: {Multiselect, TheMask},
  props: {
    tomador: {type: Object, required: true},
    paisTomador: {type: String, default: 'BR'},
    substituicao: {type: Boolean, default: false},
    ranfs: {type: Boolean, default: false},
    cpfCnpjInvalid: {type: Boolean, default: false},
    tomadorIsPrestador: {type: Boolean, default: false},
    errorCep: {type: Boolean, default: false},
    submitted: {type: Boolean, default: false},
    erroRazaoSocial: {type: Boolean, default: false},
    erroEndereco: {type: Boolean, default: false},
    validation: {
      type: Object,
      default: () => ({
        cpfCnpj: false,
        razaoSocial: false,
        cep: false,
        endereco: false,
        numero: false,
        bairro: false,
        complemento: false,
      })
    },
  },
  data() {
    return {
      paises: [],
      isLoading: false,
    };
  },
  computed: {
    localTomador() {
      return this.tomador;
    },
    paisTomadorLocal: {
      get() {
        return this.paisTomador;
      },
      set(val) {
        this.$emit('update:paisTomador', val);
      },
    },
    prestadorORtomador() {
      return !this.ranfs ? "Tomador" : "Prestador";
    },
    isEstrangeiro() {
      return this.paisTomadorLocal !== 'BR';
    },
    telefoneValido() {
      const tel = this.localTomador.sep_telefone_tomador;
      if (!tel) return null;
      return validarTelefoneBR(tel);
    },
    emailValido() {
      const email = this.localTomador.sep_email_tomador;
      return validarEmail(email);
    },
    cepValido() {
      const cep = this.localTomador.sep_cep_tomador;
      if (!cep) return null;
      // Remove tudo que não for dígito
      const digitos = cep.replace(/\D/g, '');
      // CEP deve ter exatamente 8 dígitos
      if (digitos.length !== 8) return false;
      // Rejeita CEPs com todos os dígitos iguais (00000000, 11111111, etc)
      return !/^(\d)\1{7}$/.test(digitos);
    },
  },
  methods: {
    alterPais() {
      this.$emit('alter-pais', this.paisTomadorLocal);
    },
    pesquisarPais(search) {
      if (search && search.length > 1) {
        this.isLoading = true;
        autocompletePaises({query: search}).then(response => {
          if (response.status && response.dados) {
            this.paises = response.dados;
          }
        }).catch(error => {
          console.error(error);
        }).finally(() => {
          this.isLoading = false;
        });
      }
    },
    labelPais({pas_codigo, pas_nome}) {
      return `${pas_codigo} - ${pas_nome}`;
    },
    focusCep() {
      this.$refs.sep_cep_tomador?.focus();
    },
    focusEndereco() {
      this.$refs.sep_endereco_tomador?.focus();
    },
    focusNumero() {
      this.$refs.sep_numero_endereco_tomador?.focus();
    },
  },
};
</script>
